import React, {PureComponent} from 'react';
import ShopItem from './shop_item';
import EmptyShopResult from './EmptyShopResult';
import ShopItemInterface from 'app/interfaces/shop/ShopItemInterface';
import LootInterface from 'app/interfaces/LootInterface';
import {ShopUserInterface} from 'app/store/ShopStore';
import UserInterface from 'app/interfaces/UserInterface';

export interface ShopItemsProps {
    lootboxes: Array<ShopItemInterface & {
        game?: string
        langs?: {[key: string]: string}
        set_items?: LootInterface[]
    }>
    user: ShopUserInterface | UserInterface
    currency?: string
    hiddenEmpty?: boolean
    afterBuy?: () => void
    scrollToTopBlock?: () => void
    isCasinoPage?: boolean
    isSet?: boolean
}

export default class ShopItems extends PureComponent<ShopItemsProps> {
    render(): React.ReactNode {
        const {
            lootboxes,
            user,
            currency = '',
            hiddenEmpty,
            afterBuy,
            scrollToTopBlock,
            isCasinoPage,
            isSet
        } = this.props;

        if (lootboxes.length === 0) {
            return hiddenEmpty ? null : <EmptyShopResult currency={currency}/>;
        }

        return <div className="market__lootboxes--row">
            {lootboxes.map((lootbox, index: number) => <ShopItem
                key={`lootbox-${lootbox.id}-${index}`}
                {...lootbox}
                currency={lootbox.currency ?? currency}
                afterBuy={afterBuy}
                user={user as ShopUserInterface}
                isCasinoPage={isCasinoPage}
                isSet={isSet}
                scrollToTopBlock={scrollToTopBlock}
            />)}
        </div>;
    }
}
